import { render, staticRenderFns } from "./2021TechTrendsJP.vue?vue&type=template&id=74736272"
import script from "./2021TechTrendsJP.vue?vue&type=script&lang=js"
export * from "./2021TechTrendsJP.vue?vue&type=script&lang=js"
import style0 from "./2021TechTrendsJP.vue?vue&type=style&index=0&id=74736272&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports